<script lang="ts">
	import { Button, Select, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { control_bluetooth_device_ios } from 'src/services/native_container_requests_ios';
	import { control_bluetooth_device_android } from 'src/services/native_container_requests_android';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { bindSettingsDrilldownBack, bindStickyBottomAction } from 'src/helpers/sticky_bottom_action';
	import {
		isBleSettingsSessionReady,
		persistBleDeviceSetting,
		readStoredBleDevice,
		resumeBleSettingsConnectionIfNeeded,
	} from 'src/helpers/ble_settings_session';
	import DynamicAlert from './DynamicAlert.svelte';

	export let device;

	let hadSession = false;
	let clockFormat = readStoredBleDevice(device)?.clockFormat || '24-hour';

	$: sessionReady = isBleSettingsSessionReady($controlBleDevice.connectionState);
	$: if (sessionReady) hadSession = true;
	$: resumeBleSettingsConnectionIfNeeded(device.id, $controlBleDevice);
	$: controlsDisabled = !sessionReady || !$app;
	const options = [
		{ title: $format('select_option_12_hour', { default: '12-hour' }), value: '12-hour' },
		{ title: $format('select_option_24_hour', { default: '24-hour' }), value: '24-hour' },
	];

	const goBackToSettingsList = bindSettingsDrilldownBack();

	const onSave = () => {
		const isIOS = $os === 'IOS';
		if ($controlBleDevice.connectionState === 2) {
			const command = clockFormat === '12-hour' ? 'clockMode12' : 'clockMode24';
			isIOS
				? control_bluetooth_device_ios(device.id, command)
				: control_bluetooth_device_android(device.id, command);

			persistBleDeviceSetting(device, { clockFormat });
			goBackToSettingsList?.();
		} else {
			isIOS
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	const { stickyBottomAction, setStickyBottomAction } = bindStickyBottomAction();

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			setStickyBottomAction({
				onClick: onSave,
				loading: false,
				disabled: controlsDisabled,
				icon: 'fas fa-save',
			});
		} else {
			setStickyBottomAction(null);
		}
	}
</script>

<DynamicAlert showExpiredMsg={hadSession} />

<Text styleType="body-small" class="mb-s">
	{$format('text_clock_format', {
		default:
			'Choose how time is displayed on your device. Switch between the 12-hour and 24-hour format.',
	})}
</Text>

<Select
	id="select-clock-format"
	aria-label={$format('select_clock_format', { default: 'Select clock format' })}
	size="m"
	width="full"
	class="mb-s"
	icon="fas fa-clock"
	{options}
	disabled={controlsDisabled}
	value={{
		title: $format(`select_option_${clockFormat.toLowerCase().replace(/[\s-]/g, '_')}`, {
			default: clockFormat,
		}),
		value: clockFormat,
	}}
	on:change={(e) => (clockFormat = e.detail.value)}
/>

{#if !$showNewLayout}
	<Button disabled={controlsDisabled} size="m" width="full" on:click={onSave}>
		{$format('button_save', { default: 'Save' })}
	</Button>
{/if}
